import React from 'react';
import PropTypes from 'prop-types';
import './Modal.sass';
import cx from 'classnames';

export default class Modal extends React.PureComponent {
  close = () => {
    const {onClose} = this.props;

    if (onClose) {
      onClose();
    }
  };

  onOverlayClick = evt => {
    if (!this.refs.modalBody.contains(evt.target)) {
      this.close();
    }
  };

  render() {
    const {type, className, children} = this.props;

    return (
      <div className={cx('modal-overlay', className, type && `modal--${type}`)} onClick={this.onOverlayClick}>
        <div className={cx('modal')} ref="modalBody">
          <button className="modal__close" onClick={this.close}/>
          <div className="modal__content">
            {children}
          </div>
        </div>
      </div>
    );
  }
}

Modal.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func
};



// WEBPACK FOOTER //
// ./components/modals/Modal.js